const loadScript = async (src: string, parent: HTMLElement = document.body) => {
  return new Promise<void>((resolve, reject) => {
    const script = document.createElement('script');

    script.src = src;
    script.async = true;
    script.onload = () => {
      resolve();
    };
    script.onerror = () => {
      reject();
    };

    parent.appendChild(script);
  });
};

export default loadScript;
